import { present } from './utils';
import {
  validateAddress,
  validateCountry,
  validateVat,
  validateZip,
} from './validators';

export const billingFieldValidators = {
  firstName: {
    validators: [{ func: present, message: 'Invalid' }],
    mandatory: true,
  },
  lastName: {
    validators: [{ func: present, message: 'Invalid' }],
    mandatory: true,
  },
  country: {
    validators: [{ func: validateCountry, message: 'Invalid' }],
    mandatory: true,
  },
  address: {
    validators: [{ func: validateAddress, message: 'Invalid' }],
    mandatory: true,
  },
  city: {
    validators: [{ func: present, message: 'Invalid' }],
    mandatory: true,
  },
  zip: {
    validators: [{ func: validateZip, message: 'Invalid' }],
    mandatory: true,
  },
  vat: {
    validators: [{ func: validateVat, message: 'Invalid' }],
    mandatory: false,
  },
  company: { validators: [], mandatory: false },
};
